'use strict';
import fetch from 'fetch-polyfill';
import jQuery from 'jquery';
import $ from 'jquery';
import clipboard from './js/clipboard';
import 'jquery';
import 'jquery-migrate';
import 'jquery-mask-plugin';
import './js/fm.revealator.jquery.min';
import './js/wp.adminbar.normalizer.jquery';
import './js/pre-loader.jquery';
import './js/main';
import './scss/index.scss';
